import { Box } from '@material-ui/core';

import { FlexRow } from '@/components/shared/components/FlexRow';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface IberiaCardsNavProps {
  onNext?: () => void;
  onPrev?: () => void;
  disableNext?: boolean;
  loading?: boolean;
}

export const IberiaCardsNav = ({ onNext, onPrev, disableNext, loading }: IberiaCardsNavProps) => {
  const PrevButton = (
    <StandardButton
      loading={loading}
      // Keeps the focused field from blurring on press: its blur validation would show an error, shift
      // the layout and move the button away before the click completes
      onMouseDown={(event) => event.preventDefault()}
      onClick={onPrev}
      startIcon={!loading ? <Icon size={20}>arrow_back</Icon> : null}
    >
      <Text tId={'BACK'} />
    </StandardButton>
  );

  const NextButton = (
    <StandardButton loading={loading} main disabled={disableNext} onClick={onNext}>
      <Text tId={'CONTINUE'} />
    </StandardButton>
  );

  return (
    <FlexRow justifyContent={'space-between'} width={'100%'}>
      <Box flexShrink={0}>{onPrev && PrevButton}</Box>
      <Box flexShrink={0}>{onNext && NextButton}</Box>
    </FlexRow>
  );
};
